exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton:hover img[data-v-657c33a8] {\n\t-webkit-filter: invert(0.4) sepia(1) saturate(4) hue-rotate(180.6deg) brightness(0.9);\n\t        filter: invert(0.4) sepia(1) saturate(4) hue-rotate(180.6deg) brightness(0.9);\n\t-webkit-transition-duration: 0.1s;\n\t        transition-duration: 0.1s;\n}\n.fullsize[data-v-657c33a8] {\n\twidth: 100%;\n}\n", ""]);

// exports
